import { render, staticRenderFns } from "./ZakatSimpanan.vue?vue&type=template&id=33a053a1"
import script from "./ZakatSimpanan.vue?vue&type=script&lang=js"
export * from "./ZakatSimpanan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports